import * as Yup from "yup";

export const formValidator = () =>
	Yup.object({
		subjects: Yup.array().notRequired()
	});
